const ZONE = /(Z|[+-]\d{2}:?\d{2})$/

const pad2 = (value: number) => String(value).padStart(2, '0')

export const parseApiTime = (at: string): Date =>
    new Date(ZONE.test(at) ? at : `${at.trim().replace(' ', 'T')}Z`)

export const formatApiDay = (at: string): string => {
    const date = parseApiTime(at)
    if (Number.isNaN(date.getTime())) return at
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

export const formatApiClock = (at: string): string => {
    const date = parseApiTime(at)
    if (Number.isNaN(date.getTime())) return ''
    return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`
}

const DATE_PARTS: Intl.DateTimeFormatOptions = { month: 'numeric', day: 'numeric', year: 'numeric' }

export const formatApiDate = (at: string): string => {
    const date = /^\d{4}-\d{2}-\d{2}$/.test(at) ? new Date(`${at}T00:00:00`) : parseApiTime(at)
    if (Number.isNaN(date.getTime())) return at
    return date.toLocaleDateString('en-US', DATE_PARTS)
}

export const formatApiDateTime = (at: string): string => {
    const date = parseApiTime(at)
    if (Number.isNaN(date.getTime())) return at
    return date.toLocaleString('en-US', { ...DATE_PARTS, hour: 'numeric', minute: '2-digit' })
}
